// @flow
// @jsx h
import { h, Component } from "preact";
import { Fragment } from 'preact';
import { Text, MarkupText } from "preact-i18n";
//liste ds pays
import { withStyles, ThemeConfig } from "elc-theme";

import styles from "./style.scss";

// Utility functions
import { toLocalePrice, COUNTRIES } from "elc-commons";

type AddMeetchProps = {
  toggleAssuranceAccepted: Function,
  locale: string,
  currency: Currency,
  handleInputChange: Function,
  dataAssurance: object | null,
  currentOrder: Order,
  getAssurance: Function,
  initAssuranceMeetch: object | null,
};

type AddMeetchState = {
  assurance: object | null,
  dataAssurance: object | null,
};

class AddMeetch extends Component<
  AddMeetchProps,
  AddMeetchState,
> {
  constructor(props) {
    super(props);

    this.state = {
      assurance: null,
      dataAssurance: {
        adresse: "",
        cp: "",
        ville: "",
        pays: "fr",
        idVariation:null,
      },
      showAssuranceAnnulation: false,
      idSelected: null,
      urlCgv:null
    };

    if (props.initAssuranceMeetch != null) {
      this.setState({ assurance: props.initAssuranceMeetch });
    }

    if (props.dataAssurance != null) {
      this.setState({ idSelected: props.dataAssurance?.idVariation ? props.dataAssurance?.idVariation : null });
      this.setState({ dataAssurance: props.dataAssurance });
    }
  }


  handleAcceptAssurance = (e, item) => {
    if (item == null){
        this.setState({ idSelected: "noAssurance" });
        this.props.handleInputChange(null);
    } else {

      this.setState({ idSelected: e.target.checked ? item.id : null });
       //this.props.handleInputChange(this.state.dataAssurance);
        const updatedDataAssurance = {
          ...this.state.dataAssurance,
          idVariation: item.id
        };
         this.props.handleInputChange(updatedDataAssurance);
     
    }

  };

  onClickAssuranceAnnulation = (item) => {
    const url = item?.urlConditionsAssurance[this.props.locale === "en" ? "uk" : this.props.locale] ||"#";
    //console.log("item", item)
    this.setState({
      showAssuranceAnnulation: !this.state.showAssuranceAnnulation,
      urlCgv : url
    });
  };

  onClickCloseAssuranceAnnulation = () => {
    this.setState({ showAssuranceAnnulation: false });
  };

  componentDidMount() {
    // console.log("componentDidMount meetch", this.props);
    // console.log("componentDidMount meetch this.state", this.state);

    this.props.getAssurance();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.initAssuranceMeetch !== this.state.assurance) {
      this.setState({ assurance: nextProps.initAssuranceMeetch });
    }

      if (nextProps.dataAssurance != null && JSON.stringify(nextProps.dataAssurance) !== JSON.stringify(this.state.dataAssurance)) 
        {
        this.setState({ dataAssurance: nextProps.dataAssurance }, () => {
          this.props.handleInputChange(nextProps.dataAssurance);
      });
    }
  }

  render(
    { locale, currency }: AddMeetchProps,
    { assurance, dataAssurance, showAssuranceAnnulation, idSelected, urlCgv }: AddMeetchState,
  ) {



    return (
      <ThemeConfig.Consumer>
        {(themeConfig) => {
          return (
            <div>
 {(assurance?.variations?.length > 0) ? (
              <div>
          <div class={styles.headerTitle}  style={`color:${
                themeConfig && themeConfig.color1
                  ? themeConfig.color1
                  : ""
              };`}><h3>
                <MarkupText id={`basket.meetch.labelAssuranceAnnulation`}>Choisissez l'assurance annulation</MarkupText>
                </h3>
          </div>
    <div class={`${styles.rowAssurance} ${idSelected == null ? styles.AucunSelected : ''}`}>
        {assurance.variations.map(variation => (
          <div class={`${styles.itemAssurance} ${variation.type == 'Std' ? styles.typeStd : ''}  ${variation.type == 'Premium' ? styles.typePremium : ''} ${styles.radio} ${idSelected == variation.id ? styles.selected : ''}`}>
            <input type="radio" id={variation.type} name="AssuranceAnnulationRadio"  onChange={(e) => this.handleAcceptAssurance(e, variation)}  checked={idSelected == variation.id}/>
            <label htmlFor={variation.type}>
              <div class={`${styles.cardHead} ${styles.rowAssurance}`}>
                <div class={styles.productName}><Text id={`basket.meetch.labelAssurance${variation.type}`}>label Varaition </Text></div>
                <div class={styles.badge}><Text id={`basket.meetch.badgeAssurance${variation.type}`}>badge</Text></div>
                <div class={styles.bookingTotal}>
                  {toLocalePrice(
                      variation?.montantAssurance,
                      locale,
                      currency.isoCode,
                    )}
                  </div>
              </div>
              <div class={styles.cardContent}>
                        <ul class={styles.assuranceBenefits}>
                            <li>
                              <span>
                                  <MarkupText id={`basket.meetch.rassurance${variation.type}.ligne2`}>Ligne 2 </MarkupText>
                              </span>
                            </li>
                            <li>
                              <span>
                                <MarkupText id={`basket.meetch.rassurance${variation.type}.ligne3`}>Ligne 3 </MarkupText>                              
                              </span>
                            </li>
                            <li>
                              <span>
                                <MarkupText id={`basket.meetch.rassurance${variation.type}.ligne4`}>Ligne 4 </MarkupText>                              
                              </span>
                            </li>
                        </ul>

                          <p class={`${styles.infoNotice} ${styles.sizeExtraSmall}`}>
                            <Text id="basket.meetch.noticePart1">
                              J'ai bien pris connaissance de
                            </Text>{" "}
                            <a
                              class={styles.LienDetailAssurance}
                              href="#"
                              onClick={(e) => {
                                e.preventDefault(); // Évite le comportement par défaut du lien
                                this.onClickAssuranceAnnulation(variation);
                              }}
                            >
                              <Text id="basket.meetch.noticePart2">
                                la notice d'information et en accepte les termes
                                et conditions
                              </Text>
                            </a>
                          </p>

                        {/* <div class={styles.plusInfoAssurance}>Plus d'info</div> */}
                </div>
            </label>
          </div>
        ))}
          <div class={`${styles.itemAssurance} ${styles.noAssurance}  ${styles.radio} ${idSelected == 'noAssurance' ? styles.selected : ''}`}>
            <input type="radio" id="noAssurance" name="AssuranceAnnulationRadio"  onChange={(e) => this.handleAcceptAssurance(e, null)}/>
            <label htmlFor="noAssurance">
              <div class={`${styles.cardHead} ${styles.rowAssurance}`}>
                <div>
                  <MarkupText id={`basket.meetch.labelAssuranceNoAssurance`}><strong>Non merci</strong>, je ne désire pas d'assurance</MarkupText>      
                  
                </div>
              </div>
            </label>
          </div>
    </div>
      </div>

 ) : ( "" )}



                  {showAssuranceAnnulation && (
                    <div
                      class={`${styles.modal} ${
                        showAssuranceAnnulation ? styles.show : ""
                      }`}
                    >
                      <div
                        class={styles.overlay}
                        onClick={this.onClickCloseAssuranceAnnulation}
                      ></div>
                      <div class={`${styles.termSales}`}>
                        <header>
                          {/* <h2>
                                              <Text id="basket.termSales.title">Hide</Text>
                                            </h2> */}
                          <button
                            onClick={this.onClickCloseAssuranceAnnulation}
                          >
                            <Text id="basket.termSales.hide">CGV</Text>
                          </button>
                        </header>
                        <div class={styles.termWrapper}>
                          <iframe src={urlCgv} height="600" />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
          );
        }}
      </ThemeConfig.Consumer>
    );
  }
}

export default withStyles(AddMeetch, styles);